import React, { Fragment, useContext, useEffect, useState } from "react";
import { map, isString } from "lodash";
import TableLayout from "../../containers/TableLayout";
import PartsRow from "./PartsRow";
import Spinner from "../../containers/Spinner";
import { checkInteger, checkString, getFilterByValue } from "../../utils/utils";

export default function PartsTable({ parts }) {
    if (!parts) {
        return <div style={{
            fontSize: "14px",
            textAlign: "center"
        }}>Information not available</div>
    }

    return (
        <table id="parts-table" className="responsive" width="100%">
            <thead className={"lead__part"}>
                <tr>
                    <th>Part Number</th>
                    <th>Description</th>
                    <th>Suggested Amount</th>
                </tr>
            </thead>
            <tbody>
                {map(parts, (part, i) => (
                    <PartsRow key={i} part={part} />
                ))}
            </tbody>
        </table>
    );
}
